import React, { useState } from "react";
import { Upload, message } from "antd";
import { UploadOutlined, LoadingOutlined } from "@ant-design/icons";
import CropImg from "components/CropImg";

// const { Dragger } = Upload;

function ImageUpload({ image, setImage, isCrop = false, aspectRatio, className }) {
  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  }
  const [cropData, setCropData] = useState({ visible: false });

  const validateImageSize = (file) => {
    const fileSize = file.size / 1024; // Get the file size in KB
    const maxSize = 4096; // 5000KB = 5MB (adjust as needed)

    if (fileSize > maxSize) {
      message.error(`${file.name}-ийн хэмжээ (${maxSize}KB)-аас бага байх ёстой.`);
      return false;
    }

    return true;
  };

  const onChange = ({ file }) => {
    try {
      if (file.status === "uploading") {
        setImage({ ...image, loading: true });
        return;
      }
      if (file.status === "done") {
        if (validateImageSize(file.originFileObj)) {
          getBase64(file.originFileObj, (imageUrl) => {
            setImage({ src: imageUrl, isUpdated: true, loading: false, ext: file.name });

            // CROP
            if (isCrop)
              setCropData({
                visible: true,
              });
          });
        } else {
          setImage({ ...image, loading: false });
          return;
        }
      } else if (file.status === "error") {
        message.error(`${file.name} file upload failed.`);
        setImage({ ...image, loading: false });
      }
    } catch (error) {
      setImage({ ...image, loading: false });
      message.error(`${error}: file upload failed.`);
    }
  };

  return (
    <>
      <Upload
        name="avatar"
        listType="picture-card"
        className={className ?? "image-upload"}
        onChange={onChange}
        showUploadList={false}
        customRequest={({ file, onSuccess }) => {
          setTimeout(() => {
            onSuccess("ok");
          }, 0.5);
        }}
      >
        {image.src ? (
          <img
            src={image?.src}
            alt="avatar"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        ) : (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {image.loading === true ? (
              <LoadingOutlined />
            ) : (
              <p className="ant-upload-drag-icon">
                <UploadOutlined />
                <p className="ant-upload-text" style={{ marginTop: "5px" }}>
                  Зураг оруулах
                </p>
              </p>
            )}
          </div>
        )}
      </Upload>

      <CropImg
        visible={cropData.visible}
        imgURL={image.src}
        handleSubmit={setImage}
        handleClose={() => setCropData({ ...cropData, visible: false })}
        aspectRatio={aspectRatio}
      />
    </>
  );
}

export default ImageUpload;
